export const fonts = {
    neue: 'Neue Haas Grotesk Display Pro'
}